import { z } from 'zod';
import { nullableList } from '../../zod-helpers';
import { isoYearMonthDay, uuid } from './shared';

export const WAITLIST_STATES = [
  'pending',
  'verified',
  'invited',
  'converted',
  'unsubscribed',
] as const;
export const waitlistStateSchema = z.enum(WAITLIST_STATES);
export type WaitlistState = z.infer<typeof waitlistStateSchema>;

export const waitlistEntrySchema = z.object({
  id: uuid,
  email_masked: z.string(),
  locale: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  country: z.string().nullable().optional(),
  segments: z.array(z.string()).nullable().optional(),
  source_utm: z.record(z.string()).nullable().optional(),
  state: waitlistStateSchema,
  position: z.number().int(),
  founding_member: z.boolean().nullable().optional(),
  email_verified_at: z.string().nullable().optional(),
  created_at: z.string().nullable().optional(),
});
export type WaitlistEntry = z.infer<typeof waitlistEntrySchema>;
export const waitlistListSchema = nullableList(waitlistEntrySchema);

export const waitlistFiltersSchema = z.object({
  state: waitlistStateSchema.optional(),
});
export type WaitlistFilters = z.infer<typeof waitlistFiltersSchema>;

export const waitlistMetricsDailyEntrySchema = z.object({
  day: isoYearMonthDay,
  followers_total: z.number().int().nullable().optional(),
  fb_group_active: z.number().int().nullable().optional(),
  waitlist_total: z.number().int().nullable().optional(),
  waitlist_new: z.number().int().nullable().optional(),
});
export type WaitlistMetricsDailyEntry = z.infer<typeof waitlistMetricsDailyEntrySchema>;

export const waitlistMetricsResponseSchema = z.object({
  launch_mode: z.string(),
  waitlist_active: z.number().int(),
  waitlist_pending: z.number().int(),
  waitlist_verified: z.number().int(),
  waitlist_converted: z.number().int(),
  founding_awarded: z.number().int(),
  founding_cap: z.number().int(),
  daily_series: z.array(waitlistMetricsDailyEntrySchema),
});
export type WaitlistMetricsResponse = z.infer<typeof waitlistMetricsResponseSchema>;

export const waitlistDailyMetricsRequestSchema = z.object({
  day: isoYearMonthDay,
  followers_total: z.number().int().min(0).optional(),
  fb_group_active: z.number().int().min(0).optional(),
  waitlist_total: z.number().int().min(0).optional(),
  waitlist_new: z.number().int().min(0).optional(),
  notes: z.string().max(500).optional(),
});
export type WaitlistDailyMetricsRequest = z.infer<typeof waitlistDailyMetricsRequestSchema>;
